import Vue from 'vue'
import Vuex from 'vuex'
import { CONFIG } from "@/config.js";
import axios from "axios";

const api = axios.create({
    baseURL: CONFIG.apiBaseUrl + "api/v1/",
    // withCredentials: true,
    // xsrfCookieName: "csrftoken_new",
    // xsrfHeaderName: "X-CSRFToken"
});

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
       api: api,
       supplierTableFilter: {},
       tenderTableFilter: {},
       contractTableFilter: {},
       analysis: {},
       supplierTablePage: 1,
       supplierTablePerPage: 20,
       tenderTablePage: 1,
       tenderTablePerPage: 20,
       contractTablePage: 1,
       contractTablePerPage: 20,
       count_tenders: 0,
       count_contracts: 0

    },
    getters: {
        api: state => state.api,
        supplierTableFilter: state => state.supplierTableFilter,
        tenderTableFilter: state => state.tenderTableFilter,
        contractTableFilter: state => state.contractTableFilter,
    },
    mutations: {
        setSupplierTableFilter: function(state, filter) {
            state.supplierTableFilter = filter
        },
        setAnalysis: function(state, analysis) {
            state.analysis = analysis
        },
        setSupplierTablePage: function(state, page) {
            state.supplierTablePage = page
        },
        setSupplierTablePerPage: function(state, perPage) {
            state.supplierTablePerPage = perPage
        },
        setTenderTableFilter: function(state, filter) {
            state.tenderTableFilter = filter
        },
        setTenderTablePage: function(state, page) {
            state.tenderTablePage = page
        },
        setTenderTablePerPage: function(state, perPage) {
            state.tenderTablePerPage = perPage
        },
        setContractTableFilter: function(state, filter) {
            state.contractTableFilter = filter
        },
        setContractTablePage: function(state, page) {
            state.contractTablePage = page
        },
        setContractTablePerPage: function(state, perPage) {
            state.contractTablePerPage = perPage
        }
    },
    actions: {
        setCurrentAnalysis ({ commit }, analysis) {
            commit('setAnalysis', analysis)
            commit('setSupplierTableFilter', {})
            commit('setSupplierTablePage', 1)
            commit('setSupplierTablePerPage', 20)
            commit('setTenderTableFilter', {})
            commit('setTenderTablePage', 1)
            commit('setTenderTablePerPage', 20)
            commit('setContractTableFilter', {})
            commit('setContractTablePage', 1)
            commit('setContractTablePerPage', 20)
        }
    },
    modules: {
    }
})
